import { PayloadTypeSelector } from './PayloadTypeSelector';
import { ContentInputForm } from './ContentInputForm';
import { DesignPanel } from './DesignPanel';
import { FramePanel } from './FramePanel';
import { LogoPanel } from './LogoPanel';
import { PresetsPanel } from './PresetsPanel';
import './LeftPanel.css';

import { useAppStore } from '../../store/useAppStore';

export const LeftPanel: React.FC = () => {
  const payloadType = useAppStore(state => state.payloadType);
  return (
    <div className="left-panel">
      <PayloadTypeSelector />
      <ContentInputForm key={payloadType} />
      <div className="panel-group">
        <DesignPanel />
        <FramePanel />
        <LogoPanel />
        <PresetsPanel />
      </div>
    </div>
  );
};
